import { render, staticRenderFns } from "./sponsored-posts.vue?vue&type=template&id=2160c486&"
import script from "./sponsored-posts.vue?vue&type=script&lang=js&"
export * from "./sponsored-posts.vue?vue&type=script&lang=js&"
import style0 from "./sponsored-posts.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports